import { ProductInterface } from '../../client/redux/products/types';
import { OptionalECProductValues, EcommerceProduct } from './types';

const normalizeGaProduct = (product: ProductInterface, options?: OptionalECProductValues) => {
    const { name, sku: id, price, brand, simpleSku: variant } = product;

    return {
        name,
        id,
        price: `${price}`,
        brand,
        variant,
        ...(options || {}),
    } as EcommerceProduct;
};

export default normalizeGaProduct;
